<template>
  <v-flex>
    <v-card>
      <v-card-text>

        <div class="flex-col-12">

          <div class="flex-row">
            <div class="flex-col-12 text-center">
              <img src="../../../assets/icons/icons-success.svg"/>
            </div>
          </div>

          <br />
          <br />

          <div class="flex-row">
            <div class="flex-col-12 text-center">
              <span style="color: #007ca5; font-size: 32px; font-weight: 900;">
                CADASTRO FINALIZADO COM SUCESSO!
              </span>
            </div>
          </div>
          
          <br />

          <div class="flex-row">
            <div class="flex-col-12 text-center">
              <span style="color: #737a82;font-size: 21px;">
                Agradecemos pelo envio das informações. Agora, todos os dados passarão por uma conferência interna e, em breve, retornaremos com o status do seu cadastro. Até lá, seu login degustação segue liberado para utilização, incluindo o Cota+, nosso cotador online.
              </span>
            </div>
          </div>

          <br />
          <br />

          <div class="flex-row">
            <div class="flex-col-12 text-center">
              <v-btn 
                :style="`background-color:transparent !important; color:#7fbdd2 !important; width: 226px !important; border: 1px solid #007ca5 !important;`"
                @click="ativarAba(4)"
              >
                VOLTAR AO PORTAL
              </v-btn>
            </div>
          </div>

        </div>           

      </v-card-text>

    </v-card>
  </v-flex>
</template>


<script>

export default {

  name: "CorretorDegustacaoDadosCorretor",

  props: ["ativarAba"],

  data() {
    return {
      search: "",
      panel: 0,
    }
  },

  methods: {

    finalizar(){
      return;
    }
  },
}
</script>